/**
 * In-page navigation for Content Hubs
 */

function setup()
{
    const $content_hub_navigation = document.querySelector('[data-hub-navigation]')
    if ($content_hub_navigation)
    {
        const $content_hub_navigation_wrapper = $content_hub_navigation.querySelector(['[data-hub-navigation-items]'])
        const $navigation_sections = document.querySelectorAll('[data-navigation-section]')
        const $navigation_links = document.querySelectorAll('[data-navigation-link]')
        const $navigation_scroll_left_button = document.querySelector('[data-hub-navigation-scroll-left-button]')
        const $navigation_scroll_right_button = document.querySelector('[data-hub-navigation-scroll-right-button]')

        // Ensure native gestures don’t steal horizontal drags on touch
        // (Allow vertical panning, we handle horizontal)
        try
        {
            $content_hub_navigation_wrapper.style.touchAction = 'pan-y'
            $content_hub_navigation_wrapper.style.userSelect = 'none'
            $content_hub_navigation_wrapper.style.cursor = 'grab'
        }
        catch (_) {}

        let content_hub_navigation_wrapper_width = 0

        let current_navigation_offset = 0
        let can_scroll_left = false
        let can_scroll_right = false
        let previous_navigation_link_id = null
        let current_navigation_link_id = null
        let $current_navigation_section = null

        let setup_hub_navigation_timeout_id = null
        let animated_scrolling = false

        // Drag state
        let is_dragging = false
        let drag_start_x = 0
        let drag_start_y = 0
        let drag_start_offset = 0
        let drag_moved_px = 0
        const DRAG_CLICK_CANCEL_THRESHOLD = 6 // px
        const INTENT_LOCK_THRESHOLD = 10
        let drag_mode = 'pending' // 'pending' | 'horizontal' | 'vertical'

        function smooth_scroll_to(y_target, callback)
        {
            const max_wait_ms = 2000
            const start_time = performance.now()

            window.scrollTo({ top: y_target, behavior: 'smooth' })

            function check()
            {
                const current_y = window.scrollY
                const elapsed = performance.now() - start_time

                if (Math.abs(current_y - y_target) <= 2 || elapsed > max_wait_ms)
                {
                    callback()
                    return
                }

                requestAnimationFrame(check)
            }

            requestAnimationFrame(check)
        }

        // Smooth scroll to a navigation section
        document.addEventListener('click', (event) => 
        {
            // If we just dragged, suppress accidental clicks on links
            if (drag_moved_px > DRAG_CLICK_CANCEL_THRESHOLD)
            {
                return
            }

            const link = event.target.closest('[data-navigation-link] a')
            if (!link)
            {
                return
            }

            const href = link.getAttribute('href') || ''
	        if (!href.startsWith('#'))
            {
                return
            }

            event.preventDefault()

            const target_id = href.slice(1)
            const $target_navigation_section = document.getElementById(target_id)
            if ($target_navigation_section)
            {
                animated_scrolling = true
                smooth_scroll_to($target_navigation_section.getBoundingClientRect().top + window.scrollY + 2, () =>
                {
                    animated_scrolling = false
                    setup_hub_navigation()
                })
            }
        }, false)

        $navigation_scroll_left_button.addEventListener('click', (event) =>
        {
            current_navigation_offset += document.documentElement.clientWidth
            scroll_nav()
        })

        $navigation_scroll_right_button.addEventListener('click', (event) =>
        {
            current_navigation_offset -= document.documentElement.clientWidth
            scroll_nav()
        })

        // =========
        // Drag / Swipe (Pointer Events first, Touch fallback)
        // =========

        function begin_drag(x, y)
        {
            is_dragging = false
            drag_mode = 'pending'
            drag_start_x = x
            drag_start_y = y
            drag_start_offset = current_navigation_offset
        }

        function handle_move(x, y, prevent)
        {
            const dx = x - drag_start_x
            const dy = y - drag_start_y

            if (drag_mode === 'pending' && (Math.abs(dx) >= INTENT_LOCK_THRESHOLD || Math.abs(dy) >= INTENT_LOCK_THRESHOLD))
            {
                drag_mode = Math.abs(dx) > Math.abs(dy) ? 'horizontal' : 'vertical'
                is_dragging = drag_mode === 'horizontal'
            }

            if (drag_mode === 'horizontal' && is_dragging)
            {
                prevent()
                current_navigation_offset = drag_start_offset + dx
                scroll_nav()
            }
        }

        function move_drag(client_x)
        {
            if (!is_dragging) return
            const delta_x = client_x - drag_start_x
            drag_moved_px = Math.max(drag_moved_px, Math.abs(delta_x))
            current_navigation_offset = drag_start_offset + delta_x
            scroll_nav()
        }

        function end_drag()
        {
            if (!is_dragging) return
            is_dragging = false
            $content_hub_navigation_wrapper.style.cursor = 'grab'
            // Bounds already enforced by scroll_nav()
            // Optional: add a small inertial snap here if desired
        }

        // Pointer Events path
        if (window.PointerEvent)
        {
            $content_hub_navigation_wrapper.addEventListener('pointerdown', (e) =>
            {
                // Only react to primary button or touch
                if (e.button !== 0 && e.pointerType !== 'touch')
                {
                    return
                }
	            begin_drag(e.clientX, e.clientY)
            })

            $content_hub_navigation_wrapper.addEventListener('pointermove', (e) =>
            {
	            handle_move(e.clientX, e.clientY, () => e.preventDefault())
            })

            $content_hub_navigation_wrapper.addEventListener('pointerup', () =>
            {
                end_drag()
            })

            $content_hub_navigation_wrapper.addEventListener('pointercancel', () =>
            {
                end_drag()
            })
        }
        else
        {
            // Touch fallback
            $content_hub_navigation_wrapper.addEventListener('touchstart', (e) =>
            {
                if (!e.touches || !e.touches[0]) return
                begin_drag(e.touches[0].clientX)
            }, { passive: true })

            $content_hub_navigation_wrapper.addEventListener('touchmove', (e) =>
            {
                if (!is_dragging || !e.touches || !e.touches[0]) return
                // We are handling horizontal pan; prevent default to avoid rubber-banding
                e.preventDefault()
                move_drag(e.touches[0].clientX)
            }, { passive: false })

            $content_hub_navigation_wrapper.addEventListener('touchend', () =>
            {
                end_drag()
            })
            $content_hub_navigation_wrapper.addEventListener('touchcancel', () =>
            {
                end_drag()
            })
        }

        // Trackpad / horizontal wheel support
        $content_hub_navigation_wrapper.addEventListener('wheel', (e) =>
        {
            // If there’s horizontal intent, consume it and pan the nav
            if (Math.abs(e.deltaX) > Math.abs(e.deltaY))
            {
                e.preventDefault()
                current_navigation_offset -= e.deltaX
                scroll_nav()
            }
        }, { passive: false })

        function scroll_nav()
        {
            can_scroll_left = true
            can_scroll_right = true
            if (!$current_navigation_section)
            {
                can_scroll_left = false
            }

            // If nav fits on the screen
            if (document.documentElement.clientWidth >= content_hub_navigation_wrapper_width)
            {
                current_navigation_offset = 0
                can_scroll_left = false
                can_scroll_right = false
            }
            else
            {
                // Don't let the navigation scroll too far off either side
                if (document.documentElement.clientWidth - content_hub_navigation_wrapper_width > current_navigation_offset)
                {
                    current_navigation_offset = document.documentElement.clientWidth - content_hub_navigation_wrapper_width
                    can_scroll_right = false
                }

                if (current_navigation_offset >= 0)
                {
                    current_navigation_offset = 0
                    can_scroll_left = false
                }
            }
            
            $content_hub_navigation_wrapper.style.transform = 'translate(' + current_navigation_offset + 'px, 0)'

            // Hide or show the nav buttons depending on what's off or on screen
            if (can_scroll_left)
            {
                $navigation_scroll_left_button.classList.add('visible')
            }
            else
            {
                $navigation_scroll_left_button.classList.remove('visible')
            }

            if (can_scroll_right)
            {
                $navigation_scroll_right_button.classList.add('visible')
            }
            else
            {
                $navigation_scroll_right_button.classList.remove('visible')
            }
        }

        function setup_hub_navigation(event)
        {
            const scrollY = window.scrollY

            // Toggle stickiness of the nav
            if (scrollY > window.innerHeight)
            {
                $content_hub_navigation.classList.add('pch_sticky')
            }
            else
            {
                $content_hub_navigation.classList.remove('pch_sticky')
            }

            // Debounce the rest
            clearTimeout(setup_hub_navigation_timeout_id)
            setup_hub_navigation_timeout_id = setTimeout(() =>
            {                
                if (animated_scrolling)
                {
                    return
                }

                // Work out what navigation section we're in
                let $current_navigation_link = null
                for (let i = 0; i < $navigation_sections.length; i++)
                {
                    const $navigation_section = $navigation_sections[i]
                    const rect = $navigation_section.getBoundingClientRect()
                    const top = rect.top + scrollY

                    // If this navigation section is above or at the top of the window, mark it as current
                    // The last navigation section that this is true of is the one we actually settle on as current
                    if (top <= scrollY)
                    {
                        $current_navigation_section = $navigation_section
                        current_navigation_link_id = $current_navigation_section.getAttribute('data-navigation-section')
                        $current_navigation_link = document.querySelector('[data-navigation-link="' + current_navigation_link_id + '"]')
                    }
                    else
                    {
                        break
                    }
                }

                previous_navigation_link_id = current_navigation_link_id

                // Deactivate all navigation links
                $navigation_links.forEach($navigation_link => 
                {
                    $navigation_link.classList.remove('active')
                })

                // If there's a current navigation section, highlight it in the nav
                if ($current_navigation_section && $current_navigation_link)
                {
                    $current_navigation_link.classList.add('active')
                }

                // If the nav is wider than the screen
                const nav_padding_right = (parseFloat(window.getComputedStyle($content_hub_navigation.querySelector('nav')).paddingRight) || 0)
                content_hub_navigation_wrapper_width = $content_hub_navigation_wrapper.getBoundingClientRect().width + nav_padding_right
                if (content_hub_navigation_wrapper_width > document.documentElement.clientWidth)
                {
                    // Calculate position of the navigation wrapper to put the current nav item in the centre
                    if ($current_navigation_link)
                    {
                        const current_navigation_link_rect = $current_navigation_link.getBoundingClientRect()
                        let centre_offset = (document.documentElement.clientWidth - current_navigation_link_rect.width) / 2
                        
                        current_navigation_offset = centre_offset - (current_navigation_link_rect.left - current_navigation_offset)
                    }
                }

                // Actually update the nav
                scroll_nav()
            }, 200)
        }

        window.addEventListener('resize', setup_hub_navigation)
        window.addEventListener('scroll', setup_hub_navigation)
        setup_hub_navigation()
    }
}

export default function init()
{
    if (document.readyState === 'loading')
    {
        document.addEventListener('DOMContentLoaded', setup)
    }
    else
    {
        setup()
    }
}
